module.exports = __webpack_public_path__ + "assets/img/jishu01.d568c637.png";